import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Checkbox from '~/glm/components/guest-list/checkbox.jsx';
import SelectionCell from './selection-cell';
import styles from './selection-cell-group.scss';

const SelectionCellGroup = observer(({ group, onClick }) => {
  const selectionCells = group.map(guest => {
    return (
      <SelectionCell key={`household-selectionCell-${guest.id}`}>
        <Checkbox
          id={`household-checkbox-${guest.id}`}
          className={styles.selectionCheckbox}
          checked={guest.selected}
          onClick={() => {
            if (onClick) onClick(guest);
          }}
        />
      </SelectionCell>
    );
  });
  return <td className={styles.selectionCellsContainer}>{selectionCells}</td>;
});

SelectionCellGroup.propTypes = {
  group: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func,
};

export default SelectionCellGroup;
